import { PlanCurrencyCode, PlanRegionalPriceMap, PriceValue } from '../../../types/api';

export type RegionalPriceCell = PriceValue;

export interface PricingRow {
  planDetailId: number;
  durationMonths: number;
  label: string;
  INR: RegionalPriceCell;
  USD: RegionalPriceCell;
  CAD: RegionalPriceCell;
  EUR: RegionalPriceCell;
}

export interface PlanFeatureItem {
  id: string;
  key: string;
  label: string;
  enabled: boolean;
}

export interface SubscriptionPlanView {
  id: string;
  name: string;
  description: string;
  monthlyPrice: PlanRegionalPriceMap | null;
  yearlyPrice: PlanRegionalPriceMap | null;
  pricingGrid: PricingRow[];
  features: string[];
  subscribers: number;
  isHidden: boolean;
  isPopular: boolean;
  isFree: boolean;
  /** Reserved CRM plan. Missing API values are treated as false. */
  isDynamic: boolean;
}

export const CUSTOM_PLAN_NAME = 'Custom Plan';

export interface EditSubscriptionVariantMeta {
  planDetailId: number;
  durationMonths: number;
  connects: number;
  advanceSearch: boolean;
  limitedSupport: boolean;
  limitedChat: boolean;
  limitedChatDays: number;
  highlightedProfile: boolean;
  astroMatchmaking: boolean;
  dedicatedManager: boolean;
  dedicatedSeniorManager: boolean;
  arrangedMeetings: boolean;
  hideProfile: boolean;
}

export interface EditSubscriptionFormData {
  name: string;
  description: string;
  pricingGrid: PricingRow[];
  isPopular: boolean;
  isActive: boolean;
  isFree: boolean;
  isDynamic: boolean;
  variants: EditSubscriptionVariantMeta[];
}

/** Currencies shown in the edit modal pricing grid */
export const PRICING_GRID_CURRENCIES: PlanCurrencyCode[] = ['INR', 'USD', 'CAD', 'EUR'];

export const PLAN_CURRENCIES: PlanCurrencyCode[] = ['INR', 'USD', 'CAD', 'EUR'];
